import useQuery from './useQuery';

/** M9 (#169): the org's stocking locations (name, address, default flag, part
 * count). Any member can read; writes are Owner/Manager. */
function useLocationsQuery(sellerId, params) {
  return useQuery(`/sellers/${sellerId}/locations/`, {
    enabled: Boolean(sellerId),
    staleTime: 60 * 1000,
    ...params,
  });
}

export default useLocationsQuery;
